import { makeStyles } from "@material-ui/core/styles";
import { Height } from "@material-ui/icons";


export const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      backgroundColor: "#424242",
      color: "#fff",
      height: "100%"
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      backgroundColor: "#424242",
      color: "#fff",
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      paddingTop: 50,
      backgroundColor: "#424242",
      color: "#fff"
    },
  }));